module.exports = __webpack_public_path__ + "static/media/Discovery-Target.5b2028f2.svg";